import { render, staticRenderFns } from "./AuthSignupRegisterForm.vue?vue&type=template&id=2f5e7de6"
import script from "./AuthSignupRegisterForm.vue?vue&type=script&lang=js"
export * from "./AuthSignupRegisterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports